import {
  Box,
  HStack,
  SimpleGrid,
  useMultiStyleConfig,
  VStack,
} from '@chakra-ui/react';
import React from 'react';

import Divider, { DividerColorScheme } from '../Divider';
import Link from '../Link';
import { Text } from '../Text';
import { ActionDefinition, LinkGroup } from '.';

interface ActionableGroupedLinksProps {
  action: ActionDefinition;
  linkGroups: LinkGroup[];
}

const ActionableGroupedLinks: React.FC<ActionableGroupedLinksProps> = ({
  action,
  linkGroups,
}) => {
  const Styles = useMultiStyleConfig('ActionableGroupedLinks', {});
  return (
    <Box sx={Styles.container}>
      <VStack sx={Styles.actionSection}>
        <HStack
          spacing={2}
          alignItems="center"
          width="full"
          justifyContent="start"
        >
          {action.icon}
          <Text as="h3" sx={Styles.actionHeading}>
            {action.heading}
          </Text>
        </HStack>
        <Divider colorScheme={DividerColorScheme.WHITE} />
        <Text>{action.content}</Text>
      </VStack>
      <VStack sx={Styles.linksSection} spacing={4}>
        {linkGroups.map((group, groupIndex) => (
          <SimpleGrid key={groupIndex} spacing={4} sx={Styles.linkGroup}>
            <Box>
              {group.heading && (
                <Text as="h3" sx={Styles.linkGroupHeading}>
                  {group.heading}
                </Text>
              )}
              {group.details && (
                <Text as="small" sx={Styles.linkGroupDetail}>
                  {group.details}
                </Text>
              )}
            </Box>
            <SimpleGrid columns={[1, null, 2]} spacing={4}>
              {group.links.map((link, linkIndex) => (
                <Link key={linkIndex} to={link.href} arrow width="full">
                  {link.icon}
                  <Box>{link.content}</Box>
                </Link>
              ))}
            </SimpleGrid>
          </SimpleGrid>
        ))}
      </VStack>
    </Box>
  );
};

export default ActionableGroupedLinks;
